module.exports = __webpack_public_path__ + "fce17861fb1fbda0416ffe29d9004bc0.glb";